export default function newModalRent() {

    const newModal = document.querySelectorAll('.new-modal-rent');
    const newModalRent = document.querySelectorAll('.js-new-modal-rent');
    const newModalClose = document.querySelectorAll('.js-new-modal-rent-close');
    var distance = 0;

    document.addEventListener('click', e => {
        if (e.target.classList.contains('js-new-modal-rent')) {
            let image = e.target.dataset.image;
            let title = e.target.dataset.title;
            let modal = document.querySelector('.new-modal-rent');

            if (modal) {
                distance = window.pageYOffset;
                disable_scroll();
                modal.querySelector(".new-form__title").innerHTML = title;
                modal.querySelector(".new-modal-rent__image img").src = image;
                modal.classList.add("new-modal-rent_open");
            }
        }
    })

    // if (newModalRent.length) {
    //     for (let open of newModalRent) {
    //         open.addEventListener('click', function () {

    //             let image = open.dataset.image;
    //             let title = open.dataset.title;
    //             let modal = document.querySelector('.new-modal-rent');

    //             if (modal) {
    //                 distance = window.pageYOffset;
    //                 disable_scroll();
    //                 modal.querySelector(".new-form__title").innerHTML = title;
    //                 modal.querySelector(".new-modal-rent__image img").src = image;
    //                 modal.classList.add("new-modal-rent_open");
    //             }
    //         });
    //     }
    // }

    function modal_close() {
        document.querySelector(".new-modal-rent_open")?.classList.remove("new-modal-rent_open");
    }

    function disable_scroll() {
        document.querySelector(".site-container").classList.add("dis-scroll");
        document.querySelector(".site-container").scrollTo({
            top: distance,
            left: 0,
        });
    }

    function enable_scroll() {

        document.querySelector(".site-container").classList.remove("dis-scroll");

        if (distance != 0) {
            window.scrollTo({
                top: distance,
                left: 0,
            });
        }

    }

    if (newModalClose.length) {
        for (let close of newModalClose) {
            close.addEventListener('click', function () {
                modal_close();
                enable_scroll();
            });
        }
    }

    document.addEventListener('keydown', function (e) {
        let keyCode = e.keyCode;
        if (keyCode === 27) {
            modal_close();
            enable_scroll();
        }
    });

    if (newModal.length) {
        for (let modal of newModal) {
            modal.addEventListener('mousedown', function (e) {
                if (e.target.classList.contains("new-modal-rent")) {
                    document.querySelector('.new-modal-rent_open')?.classList.remove('new-modal-rent_open');
                    enable_scroll();
                }
            });
        }
    }
}